module.exports = __webpack_public_path__ + "img/704.2202b2b4.png";